<template>
  <div :key="newsfeedKey">
    <SPreloader />
    <SubHeaderCategories :categories="categories" pageName="Feed" />
    <div class="header-spacer"></div>
    <div class="container">
      <div class="row">
        <!-- Main Content -->

        <main
          class="col col-xl-9 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12"
        >
          <div class="mobile-button">
            <SButtonMaterial
              v-if="isMobile"
              class="cta-button btn-size"
              buttonType="button"
              color="white"
              textColor="primary"
              borderColor="primary"
              materialClass="dense"
              text="refer friends"
              iconLeftText="true"
              svgIcon="/img/gift-points.svg"
              @button="ctaClick"
            />
            <SButtonMaterial
              v-if="isMobile"
              class="create-group-btn md-elevation-4 btn-size"
              buttonType="button"
              color="primary"
              textColor="white"
              materialClass="dense"
              text="create group"
              iconLeftText="groups"
              iconColor="white"
              @button="openNewGroupModal"
            />
          </div>
          <SFilterNewsFeed
            @filterCategory="setCategory"
            @filterCondition="setCondition"
            @filterTrade="setTrade"
          />
          <div
            id="nf-item-gallery"
            v-if="!is_fetching_feed"
            class="md-layout md-gutter"
            ref="feed"
          >
            <div
              v-for="(item, index) in feed_to_show"
              :key="index"
              class="md-layout-item"
              :class="{ 'system-message': item.feedType === 'SYSTEM_MESSAGE',
                        'not-show': !isItemToShow(item)}"
            >
              <SNewPostGroup
                :post="item"
                v-if="item.feedType === 'NEW_GROUP_POST'"
              />
              <SNewItemMaterial
                :item="item"
                v-if="item.feedType === 'NEW_ITEM' && isItemAvailable(item)"
                @openWindowPopup="openChat(item)"
                @deleteItem="reloadData(index)"
              />
              <!-- <SNewGarageSaleMaterial
                :item="item"
                v-if="item.feedType === 'NEW_GARAGE'"
                @openWindowPopup="openChat(item)"
              /> -->
              <SLendedItemMaterial
                :item="item"
                v-if="isItemLended(item)"
                @openWindowPopup="openChat(item)"
                @deleteItem="reloadData(index)"
              />
              <SNewJoinInvitationMaterial
                :request="item"
                v-if="
                  item.feedType === 'JOIN_INVITATION' &&
                  item.situation === membership_situation.INVITED
                "
                @openWindowPopup="openChat(item)"
                @membershipSituation="removeFromNewsFeed(index)"
              />
              <SNewArrivalMaterial
                :arrival="item"
                v-if="item.feedType === 'NEW_ARRIVAL'"
                @openWindowPopup="openChat(item)"
              />
              <SNewModeratorInvitationMaterial
                :request="item"
                v-if="item.feedType === 'MODERATION_INVITATION'"
                @openWindowPopup="openChat(item)"
                @membershipSituation="removeFromNewsFeed(index)"
              />
              <SNewMemberMaterial
                :member="item"
                v-if="item.feedType === 'NEW_MEMBER'"
                @openWindowPopup="openChat(item)"
              />
              <SNewRequestJoinMaterial
                :request="item"
                v-if="item.feedType === 'REQUEST_TO_JOIN'"
                @openWindowPopup="openChat(item)"
              />
              <SNewItemRequest
                :item="item"
                v-if="item.feedType === 'NEW_ITEM_REQUEST'"
              />
              <SNewSystemMessage
                :message="item"
                v-if="item.feedType === 'SYSTEM_MESSAGE'"
              />
            </div>
            <div
              v-if="isEmptyFeed"
              class="ui-block px-4 py-5 text-center"
              data-cy="fetchingContent"
            >
              <span>
                <span
                  >Sorry, no items matched the filter options.
                  <md-icon>sentiment_very_dissatisfied</md-icon></span
                >
              </span>
            </div>
          </div>
          <SLazyContent
            v-if="is_fetching_feed"
            :numberOfItems="2"
            data-cy="fetchingContent"
          />
        </main>

        <aside
          class="col col-xl-3 order-xl-3 col-lg-3 order-lg-3 col-md-3 col-sm-3 col-12 mt-4 feed-aside"
        >
          <ReferFriendsCTA class="mb-4" v-if="!isMobile" />
          <SNewGroupWidget v-if="!isMobile" />
          <GroupsYouMayLike :groups="groupsYouMayLike" />
        </aside>

        <!-- ... end Right Sidebar -->
      </div>
    </div>
    <Footer />
    <a
      class="back-to-top arrow-top"
      href="#"
      v-if="pageBottom"
      style="z-index: 17"
    >
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GroupsYouMayLike from "@/components/molecules/GroupsYouMayLike";
import Footer from "./Footer.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
// import SNewGarageSaleMaterial from "@/material-components/organisms/SNewGarageSaleMaterial";
import SLendedItemMaterial from "@/material-components/organisms/SLendedItemMaterial";
import SNewSystemMessage from "@/components/organisms/SNewSystemMessage";
import ChatHelperVue from "../mixins/ChatHelper.vue";
import membershipSituation from "@/enum/membership-situation";
import UserHelperVue from "../mixins/UserHelper.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import item_status from "@/enum/item-status";
import ItemHelperVue from "../mixins/ItemHelper.vue";
import ReferFriendsCTA from "@/material-components/atoms/ReferFriendsCTA.vue";
import SNewMemberMaterial from "@/material-components/organisms/SNewMemberMaterial.vue";
import SFilterNewsFeed from "@/material-components/organisms/SFilterNewsFeed.vue";
import SNewGroupWidget from "@/components/atoms/SNewGroupWidget";
import SNewRequestJoinMaterial from "@/material-components/organisms/SNewRequestJoinMaterial.vue";
import SNewItemRequest from "@/material-components/organisms/SNewItemRequest.vue";
import SNewJoinInvitationMaterial from "@/material-components/organisms/SNewJoinInvitationMaterial.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import SubHeaderCategories from "@/material-components/molecules/SubHeaderCategories.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SLazyContent from "@/material-components/organisms/SLazyContent";
import SNewArrivalMaterial from "@/material-components/organisms/SNewArrivalMaterial";
import SNewPostGroup from "@/material-components/organisms/SNewPostGroup";
import SNewModeratorInvitationMaterial from "../material-components/organisms/SNewModeratorInvitationMaterial.vue";

export default {
  name: "NewsFeed",
  components: {
    GroupsYouMayLike,
    SNewItemMaterial,
    // SNewGarageSaleMaterial,
    SLendedItemMaterial,
    SNewSystemMessage,
    SPreloader,
    ReferFriendsCTA,
    SFilterNewsFeed,
    SNewArrivalMaterial,
    SNewMemberMaterial,
    SNewGroupWidget,
    SNewRequestJoinMaterial,
    SNewItemRequest,
    SNewJoinInvitationMaterial,
    SubHeaderCategories,
    SLazyContent,
    Footer,
    SButtonMaterial,
    SNewModeratorInvitationMaterial,
    SNewPostGroup,
  },
  mixins: [ChatHelperVue, UserHelperVue, ItemHelperVue, GroupHelperVue],
  data() {
    return {
      membership_situation: membershipSituation,
      itemStatus: item_status,
      is_fetching_feed: false,
      feed_length: 0,
      feed_to_show: [],
      end_of_feed: false,
      selectedKeyChat: {},
      loginLocation: null,
      newsfeedKey: 0,
      filterByCategory: "",
      filterByItemCondition: "",
      filterByTradeType: "",
      isMobile: window.innerWidth < 1024 ? true : false,
      categories: [
        {
          name: "free",
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "book",
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "auto",
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "clothing",
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "electronic",
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "family",
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "games",
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "household",
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "music",
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "sports",
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "tools",
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "video",
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "other",
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["setNewGroupPrivacy"]),
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$refs.rightStickyBar.openClosePopup();
      this.setReadMessage();
    },
    async setReadMessage() {
      let type = "";

      const unreadMessages =
        this.$parent.$refs.sLoggedHeader.$refs.sHeaderMessages.messages;
      const result = unreadMessages.find(
        (msg) => msg.key === this.selectedKeyChat.key
      );

      if (typeof result !== "undefined") {
        if (
          result.type === "USERS_ITEM_MESSAGE" ||
          result.type === "MY_ITEM_MESSAGE"
        ) {
          type = "item";
        } else if (
          result.type === "MY_MODERATOR_GROUP_MESSAGE" ||
          result.type === "MY_GROUP_MESSAGE"
        ) {
          type = "group";
        }

        if (type == "item") {
          await this.setReadItemMessages({
            msgsIds: [result.messages[result.messages.length - 1].id],
          });
        } else if (type == "group") {
          await this.setReadGroupMessages({
            msgsIds: [result.messages[result.messages.length - 1].id],
          });
        }
        await this.fetchUserMessages();
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    removeFromNewsFeed(i) {
      this.removeFromFeed({ index: i });
    },
    reloadData(index) {
      this.removeFromNewsFeed(index);
      this.feed_to_show.splice(index, 1);
      this.newsfeedKey += 1;
    },
    async loadData() {
      this.is_fetching_feed = true;
      await this.fetchFeed();
      this.feed();
      this.is_fetching_feed = false;
      if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === 'aws') {
        this.loginLocation = await this.getUserLocation();
        await this.saveUserLocation({ location: this.loginLocation.country });
      }
    },
    onFeedScroll() {
      if (this.is_fetching_feed || this.end_of_feed) return;

      const feedFooter = this.$refs["feed"];

      if (feedFooter) {
        const marginBottomFeed = feedFooter.getBoundingClientRect().bottom;
        const innerHeight = window.innerHeight;

        if (marginBottomFeed - innerHeight < 50) this.feed();
      }
    },
    feed() {
      if (this.end_of_feed) return;

      this.is_fetching_feed = true;
      let feed = [...this.getFeed];
      feed.sort((a, b) => {
        const dateA = new Date(this.getLastItemTimeStamp(a)) || new Date();
        const dateB = new Date(this.getLastItemTimeStamp(b)) || new Date();
        return dateB - dateA;
      });

      let filteredFeed = this.filterFeed(feed);

      let result = [];
      if (filteredFeed.length > 0) {
        result = [
          ...filteredFeed.slice(this.feed_length, this.feed_length + 19),
        ];
      }

      if (result.length === 0) {
        this.end_of_feed = true;
        this.is_fetching_feed = false;
        return;
      }

      this.feed_to_show.push(...result);
      //TODO Future: Card de anuncio a cada X cards
      // this.feed_to_show.push({ ads: true });
      this.feed_length += result.length;
      this.is_fetching_feed = false;
    },
    isItemAvailable(item) {
      return item.status === this.itemStatus.IDLE;
    },
    isItemLended(item) {
      return item.status != this.itemStatus.IDLE && item.type === 3;
    },
    isItemToShow(item) {
      if (item.feedType === "NEW_ITEM")
        return (item.status === this.itemStatus.IDLE || item.type === 3)
      return true
    },
    setCategory(value) {
      this.filterByCategory = value;
      this.filter();
    },
    setCondition(value) {
      this.filterByItemCondition = value;
      this.filter();
    },
    setTrade(value) {
      this.filterByTradeType = value;
      this.filter();
    },
    filter() {
      this.feed_length = 0;
      this.feed_to_show.length = 0;
      this.end_of_feed = false;
      this.feed();
    },
    handleAllFilters(filteredFeed) {
      if (!this.filterByItemCondition && !this.filterByTradeType) {
        return filteredFeed.filter(
          (item) =>
            item.category === this.filterByCategory &&
            item.status === this.itemStatus.IDLE
        );
      } else if (this.filterByItemCondition && this.filterByTradeType) {
        return filteredFeed.filter(
          (item) =>
            item.category === this.filterByCategory &&
            item.status === this.itemStatus.IDLE &&
            item.condition === this.filterByItemCondition &&
            item.type === this.filterByTradeType
        );
      } else if (this.filterByItemCondition) {
        return filteredFeed.filter(
          (item) =>
            item.category === this.filterByCategory &&
            item.status === this.itemStatus.IDLE &&
            item.condition === this.filterByItemCondition
        );
      } else {
        return filteredFeed.filter(
          (item) =>
            item.category === this.filterByCategory &&
            item.status === this.itemStatus.IDLE &&
            item.type === this.filterByTradeType
        );
      }
    },
    filterFeed(arr) {
      if (arr === undefined || !Array.isArray(arr)) return [];
      let filteredFeed = [...arr];
      if (
        !this.filterByCategory &&
        !this.filterByItemCondition &&
        !this.filterByTradeType
      ) {
        return filteredFeed;
      }
      if (this.filterByCategory !== "") {
        return this.handleAllFilters(filteredFeed);
      }
      if (this.filterByItemCondition !== "") {
        if (!this.filterByTradeType) {
          return filteredFeed.filter(
            (item) =>
              item.condition === this.filterByItemCondition &&
              item.status === this.itemStatus.IDLE
          );
        } else {
          return filteredFeed.filter(
            (item) =>
              item.condition === this.filterByItemCondition &&
              item.status === this.itemStatus.IDLE &&
              item.type === this.filterByTradeType
          );
        }
      }
      if (this.filterByTradeType !== "") {
        return filteredFeed.filter(
          (item) =>
            item.status === this.itemStatus.IDLE &&
            item.type === this.filterByTradeType
        );
      }
      return filteredFeed;
    },
    openNewGroupModal() {
      this.setNewGroupPrivacy(1);
      $("#create-group").modal("show");
    },
    ctaClick() {
      this.$router.push("/s-app/invite-friends");
    },
  },
  computed: {
    ...mapGetters({
      getFeed: "getMyFeed",
      groupsYouMayLike: "getGroupsYouMayLIke",
    }),
    isEmptyFeed() {
      if (this.is_fetching_feed === true) return false;
      return this.feed_length === 0;
    },
  },
  watch: {
    is_fetching_feed(newValue) {
      if (newValue === true) {
        document.body.classList.add("block-scroll");
      } else {
        document.body.classList.remove("block-scroll");
      }
    },
  },
  mounted() {
    this.loadData();
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onFeedScroll);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onFeedScroll);
  },
};
</script>

<style lang="scss" scoped>
.col-xl-9 {
  padding: 0;
}
.cta-button {
  background: $white;
}
.btn-size {
  width: 175px;
}
.container {
  display: flex;
  justify-content: center;
  margin-top: 92px;
  min-width: 100%;
}
.container .row {
  margin: 0;
  justify-content: center;
  max-width: 1800px;
  flex-wrap: nowrap;
}
.container .row main {
  flex: 0 0 78%;
  max-width: unset;
}

.feed-aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 12px 0px 12px;
  flex: 0 0 19%;
}

.electronic-class {
  margin-right: -1px !important;
}

.clothing-class {
  margin-right: 2px !important;
}

.household-class {
  margin-right: 3px !important;
}
.not-show {
  display: none !important;
}

// TODO: Future, 2 items per row when all cards done
#nf-item-gallery {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding-right: 0;
  justify-content: center;
}

#nf-item-gallery > div {
  box-sizing: border-box;
}
.system-message {
  flex: 100% !important;
  max-width: unset !important;
  margin-right: unset !important;
}

.md-layout-item {
  max-width: 576px;
  margin: 0 8px 16px !important;
  display: flex;
  justify-content: center;
  padding: 0 !important;
}
@media screen and (max-width: 1024px) {
  .container {
    margin-top: 135px;
  }
  .container .row {
    flex-wrap: wrap;
  }
  .container .row main {
    flex: 0 0 100%;
  }
  .filter-news-feed {
    justify-content: center;
  }
  .mobile-button {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }
  .mobile-button button {
    margin: 0 8px;
  }
}
</style>

<style lang="scss" scoped>
/* Animations */
.slide-top {
  -webkit-animation: slide-top 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-top 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-top {
  0% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@-webkit-keyframes slide-top {
  0% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

</style>

<style>
.block-scroll {
  overflow: hidden;
}
</style>
